import * as React from "react";
const SvgVan = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.75 5.5c0-.69.56-1.25 1.25-1.25h13.012a1.25 1.25 0 0 1 1.197.89l1.012 3.373a2.75 2.75 0 0 0 1.136 1.516l2.324 1.509c.355.23.569.625.569 1.048V16.5c0 .69-.56 1.25-1.25 1.25h-.26a3.25 3.25 0 0 0-6.48 0H9.74a3.25 3.25 0 0 0-6.48 0H3c-.69 0-1.25-.56-1.25-1.25v-5.25H9a.75.75 0 0 0 0-1.5H1.75V5.5Zm-1.5 5v6A2.75 2.75 0 0 0 3 19.25h.5a3.25 3.25 0 0 0 6 0h5a3.25 3.25 0 0 0 6 0h.5a2.75 2.75 0 0 0 2.75-2.75v-3.914c0-.931-.471-1.8-1.252-2.306l-2.324-1.51a1.25 1.25 0 0 1-.517-.688L18.646 4.71a2.75 2.75 0 0 0-2.634-1.96H3A2.75 2.75 0 0 0 .25 5.5v5Zm4.5 7.5a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0Zm12.75-1.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgVan;
